/**
 * API 配置
 * 统一管理后端 API 地址和其他配置
 */

// 环境检测
const isDevelopment = import.meta.env.DEV;
const isProduction = import.meta.env.PROD;

// 获取 API 基础地址
// 注意：使用 !== undefined 检查，因为空字符串是有效值（表示使用相对路径/代理）
const getBaseURL = () => {
  const envURL = import.meta.env.VITE_API_BASE_URL;
  // 如果环境变量已定义（包括空字符串），使用环境变量值
 if (envURL !== undefined) {
    return envURL;
  }
  // 否则使用默认值：开发环境空字符串，生产环境使用 nginx 代理也是空字符串
  return '';
};

// API 基础配置
export const API_CONFIG = {
  // 后端 API 基础地址
  // 开发环境：通过 Vite proxy 代理
  // 生产环境：通过 nginx proxy 代理
  BASE_URL: getBaseURL(),
  
  // 请求超时时间 (毫秒)
  TIMEOUT: 60000,
  
 // 令牌刷新阈值 (秒) - 令牌过期前多少秒开始刷新
  TOKEN_REFRESH_THRESHOLD: 30,
};

// API 端点配置
export const API_ENDPOINTS = {
  // 认证相关
 AUTH: {
    LOGIN: '/api/auth/login',
    LOGOUT: '/api/auth/logout',
    REGISTER: '/api/auth/register',
    REFRESH: '/api/auth/refresh',
    ME: '/api/auth/me',
    CHANGE_PASSWORD: '/api/auth/change-password',    ME_CHANGE_PASSWORD: '/api/auth/me/change-password',    ME_STUDENT_LINK: '/api/auth/me/student-link',
    ME_STUDENTS: '/api/auth/me/students',
    ME_ATTENDANCE_RECORDS: '/api/auth/me/attendance-records',
    USER_STUDENT_LINK: '/api/auth/user-student-link',
    USER_STUDENT_IDS: '/api/auth/user-student-ids',
    CREATE_STUDENT_LINK: '/api/auth/student-link',
    DELETE_STUDENT_LINK: '/api/auth/student-link',
  },
  
  // 学员管理
 STUDENTS: {
    LIST: '/api/students',
    DROPDOWN: '/api/students/list',
    DETAIL: (id) => `/api/students/${id}`,
    ACCOUNTS: (id) => `/api/students/${id}/course-accounts`,
    CREATE: '/api/students',
    UPDATE: (id) => `/api/students/${id}`,
    DELETE: (id) => `/api/students/${id}`,
    CALCULATE_GRADE: '/api/students/calculate-grade',
  },
  
  // 课程管理
 COURSES: {
    LIST: '/api/courses',
    NAMES: '/api/courses/names',
    DETAIL: (id) => `/api/courses/${id}`,
    CREATE: '/api/courses',
    UPDATE: (id) => `/api/courses/${id}`,
    DELETE: (id) => `/api/courses/${id}`,
  },
  
  // 上课记录 (考勤)
  ATTENDANCE: {
    LIST: '/api/attendance-records',
    DETAIL: (id) => `/api/attendance-records/${id}`,
    CREATE: '/api/attendance-records',
    UPDATE: (id) => `/api/attendance-records/${id}`,
    DELETE: (id) => `/api/attendance-records/${id}`,
    VOID: (id) => `/api/attendance-records/${id}/void`,
  },
  
  // 账务记录 (购课)
  PURCHASE: {
    LIST: '/api/purchase-records',
    DETAIL: (id) => `/api/purchase-records/${id}`,
    CREATE: '/api/purchase-records',
    UPDATE: (id) => `/api/purchase-records/${id}`,
    DELETE: (id) => `/api/purchase-records/${id}`,
  },
  
  // 作品管理
  WORKS: {
    LIST: '/api/works',
    DETAIL: (id) => `/api/works/${id}`,
    CREATE: '/api/works',
    UPDATE: (id) => `/api/works/${id}`,
    DELETE: (id) => `/api/works/${id}`,
  },
  
  // 课堂日志
  CLASSROOM_LOGS: {
    LIST: '/api/classroom-logs',
    DETAIL: (id) => `/api/classroom-logs/${id}`,
    CREATE: '/api/classroom-logs',
    UPDATE: (id) => `/api/classroom-logs/${id}`,
    DELETE: (id) => `/api/classroom-logs/${id}`,
  },
  
  // 文件上传
  UPLOAD: {
    PRESIGN: '/api/upload/presign',
    CONFIRM: '/api/upload/confirm',
  },
  
  // 高级报表
  ADVANCED_REPORT: {
    TOTAL_REMAINING_HOURS: '/api/advanced-report/total-remaining-hours',
    MONTHLY_CONSUMPTION_TREND: '/api/advanced-report/monthly-consumption-trend',
    STUDENT_HOURS_RANKING: '/api/advanced-report/student-hours-ranking',
    ATTENDANCE_RECORDS: '/api/advanced-report/attendance-records',
    STUDENT_COURSES: '/api/advanced-report/student-courses',
    SUMMARY: '/api/advanced-report/summary',
    LOW_HOURS_STUDENTS: '/api/advanced-report/low-hours-students',
  },
  
  // 赠送与赠课系统
  REWARDS: {
    BALANCE: (studentId) => `/api/rewards/balance/${studentId}`,
    LEDGER: '/api/rewards/ledger',
    STUDENT_LEDGER: (studentId) => `/api/rewards/ledger/student/${studentId}`,
    ADD_REFERRAL: '/api/rewards/referral',
    ADD_VOLUME_BONUS: '/api/rewards/volume-bonus',
    TRANSFER: '/api/rewards/transfer',
    CONSUME: '/api/rewards/consume',
    VOID_CONSUME: '/api/rewards/void-consume',
    STATS: '/api/rewards/stats',
    SUMMARY: '/api/rewards/summary',
    ACTIVE_STUDENTS: '/api/rewards/active-students',
    IN_TRANSIT: (studentId) => `/api/rewards/in-transit/${studentId}`,
  },
  
  // 管理员后台 - 微信绑定
  ADMIN_MINIAPP: {
    STUDENT_BINDING: (id) => `/api/miniapp/admin/student-binding/${id}`,
    UNBIND: (id) => `/api/miniapp/admin/student-binding/${id}/unbind`,
  },
};

export default API_CONFIG;
